<template>
    <!--@*页脚*@-->
    <div id="footer">
      <div class="top">
        <div class="top_div">
          <div class="word">
            <div>
              <div class="wordSize">关于网站</div>
              <div>关于我们</div>
              <div>企业动态</div>
              <div>公司产业</div>
            </div>
            <div style="margin-top: 23px">
              <div>团队动态</div>
              <div>联系我们</div>
            </div>
            <div>
              <div class="wordSize">友情链接</div>
              <div><a href="http://www.sdas.org/ target='_blank' ">山东省科学院</a></div>
              <div><a href="http://www.scsc.cn/ target='_blank' ">山东省计算中心</a></div>
              <div><a>山科智控</a></div>
            </div>
            <div style="margin-top: 40px">
              <div>山科智控山科智控</div>
              <div>山科智控山科智控</div>
              <div>山科智控山科智控</div>
            </div>
            <div>
              <div class="wordSize">联系我们</div>
              <div>电话：0531-8260 3780</div>
              <div>邮箱：shankezhikong@163.com</div>
              <div>地址:山东省济南市历下区科院路19号山科众创空间203E</div>
            </div>
          </div>
          <div class="img">
            <div>
              <img src="../../assets/img/gongzhonghao.jpg" alt="" style="margin-right: 20px;"  width="100%">
              <div>官方公众号</div>
            </div>
            <div>
              <img  src="../../assets/img/gongzhonghao.jpg" alt=""  width="100%">
              <div>APP下载</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom_div">
          <div class="left">copyright 山东山科智控数字化科技有限公司 2021-2022</div>
          <div class="right">备案号：XXXXXXXXXXXXX</div>
        </div>

      </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    /*页脚*/
    #footer {
        width: 1920px;
        height: 293px;
        background: #2D2F39;
        font-size: 14px;
    }
    .top{
      width: 100%;
      height: 241px;
    }
    .top_div{
      width: 85%;
      height: 241px;
      text-align: center;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom{
      width: 100%;
      height: 50px;
      border-top: solid 2px #121215;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 0.8;

    }
    .bottom_div{
      width: 60%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      margin: 0 auto;

    }
    .left{
      width: 500px;
      height: 16px;
    }
    .right{
      width: 382px;
      height: 16px;
    }
    ul,li,ol{
      list-style: none;
    }
    .word{
      width: 80%;
      color: #FFFFFF;
      opacity: 0.7;
      display: flex;
      justify-content: space-around;
      align-items: center;
      line-height: 30px;
      text-align: left;
    }
    .img{
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
    }
    img{
      width: 105px;
      height: 105px;
    }
    .wordSize{
      font-size: 18px;
      margin-bottom: 20px;
    }
    a{
      text-decoration: none;
      color: white;
    }
</style>
